import { inject, signal } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { Iflash } from "../../../models/iflash";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { AlertMessageService } from "../alert-msg/message.service";
import { catchError, of } from "rxjs";

export const flashcardsResolver: ResolveFn<any> = (route, state) => {
  const subjectSlug = signal(route.paramMap.get("sub") ?? "");
  const curriculumSlug = signal(route.paramMap.get("cur") ?? "");
  const _alertMessageService = inject(AlertMessageService);
  const _httpClient = inject(HttpClient);
  const baseUrl = environment.apiUrl;
  const request = _httpClient.get<Iflash>(`${baseUrl}api/website/subjects/${subjectSlug()}/flashcards?curriclum_slug=${curriculumSlug()}`).pipe(
    catchError((err) => {
      _alertMessageService.addMsg(err?.error?.msg || "Error loading Flash cards data");
      return of(undefined);
    }),
  );

  return request;
};
